var getCreativeAreaImageSize = function getCreativeAreaImageSize(viewport, mastheadSize) {
  var size;
  switch (viewport) {
    case 'xs':
    case 'sm':
      size = {
        width: 375,
        height: 180
      };
      break;
    case 'md':
    case 'lg':
      size = {
        width: 768,
        height: 280
      };
      break;
    case 'xl':
    case 'xxl':
      if (mastheadSize === 'sm') {
        size = {
          width: 420,
          height: 180
        };
      }
      if (mastheadSize === 'md') {
        size = {
          width: 420,
          height: 220
        };
      }
      if (mastheadSize === 'lg') {
        size = {
          width: 420,
          height: 370
        };
      }
      break;
    default:
      size = {
        width: 375,
        height: 180
      };
      break;
  }
  return size;
};
export default getCreativeAreaImageSize;